import { render, staticRenderFns } from "./mainjobcontent.vue?vue&type=template&id=12bcef1e"
import script from "./mainjobcontent.vue?vue&type=script&lang=js"
export * from "./mainjobcontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports